// extracted by mini-css-extract-plugin
export var boxItems = "_a9-1";
export var boxItemsLg = "_a9-2";
export var button = "_a9-7";
export var buttonHoverless = "_a9-9";
export var buttonLg = "_a9-8";
export var filterGroupBox = "_a9-0";
export var icon = "_a9-3";
export var iconSecondary = "_a9-6";
export var iconWrapper = "_a9-4";
export var iconWrapperLg = "_a9-5";
export var truncatedLabel = "_a9-a";